import { makeStyles } from '@material-ui/core/styles'

const BRAND_NAVY = '#001C57'
const HERO_BACKGROUND = '#F3F3F3'
const APP_BAR_HEIGHT = 64

const useStyles = makeStyles(theme => ({
  logo: {
    display: 'block',
    width: '48px',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    backgroundColor: '#FFFFFF',
    boxShadow: 'none',
    borderBottom: '1px solid #E0E0E0',
    borderRadius: 0,
  },
  filler: {
    flexGrow: 1,
  },
  page: {
    width: '100%',
    minHeight: '100vh',
    backgroundColor: '#FFFFFF',
  },
  hero: {
    backgroundColor: HERO_BACKGROUND,
    marginTop: APP_BAR_HEIGHT,
    display: 'flex',
    alignItems: 'center',
    minHeight: 260,
    padding: theme.spacing(6, 0),
    width: '100%',
    boxSizing: 'border-box',
    [theme.breakpoints.down('sm')]: {
      minHeight: 220,
      padding: theme.spacing(5, 0),
    },
  },
  heroContent: {
    maxWidth: 720,
  },
  welcomeBack: {
    color: '#425D69',
    fontSize: '0.75rem',
    fontWeight: 600,
    letterSpacing: '0.08em',
    lineHeight: 1.4,
    textTransform: 'uppercase',
    marginBottom: theme.spacing(1),
  },
  helloName: {
    fontFamily: '"Source Serif Pro", serif',
    fontWeight: 700,
    fontSize: '3rem',
    lineHeight: 1.15,
    color: BRAND_NAVY,
    marginBottom: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      fontSize: '2.25rem',
    },
  },
  heroSubtext: {
    color: BRAND_NAVY,
    fontSize: '1rem',
    lineHeight: 1.6,
    fontWeight: 400,
    maxWidth: 560,
    opacity: 0.88,
    [theme.breakpoints.down('sm')]: {
      fontSize: '0.9375rem',
    },
  },
  cardsSection: {
    paddingTop: theme.spacing(5),
    paddingBottom: theme.spacing(6),
    [theme.breakpoints.down('sm')]: {
      paddingTop: theme.spacing(3),
    },
  },
  helpBanner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(3),
    width: 'fit-content',
    maxWidth: '100%',
    marginTop: theme.spacing(5),
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: theme.spacing(1.5, 2),
    borderRadius: 12,
    backgroundColor: 'rgba(0, 28, 87, 0.08)',
    border: '1px solid rgba(0, 28, 87, 0.16)',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column',
      alignItems: 'flex-start',
    },
  },
  helpBannerCopy: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5),
    minWidth: 0,
  },
  helpBannerIcon: {
    color: BRAND_NAVY,
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  helpBannerText: {
    fontSize: '0.875rem',
    lineHeight: 1.4,
    color: '#172024',
    margin: 0,
  },
  helpBannerButton: {
    borderRadius: 20,
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '0.9375rem',
    padding: theme.spacing(1, 2.5),
    whiteSpace: 'nowrap',
    flexShrink: 0,
    boxShadow: 'none',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0, 28, 87, 0.2)',
    },
    [theme.breakpoints.down('xs')]: {
      width: '100%',
    },
  },
}))

export default useStyles
